<template>
   <div
      class="ancillary-seat-map-passenger-container"
      @click="handlerSelectSeat"
      :class="{ selected: SeatSelected, active: IsPassengerSelectionActive, noPointer: IsPassengerInfant, initialSeat: passenger.initialSeat }">
      <div class="passenger-cta" :class="{ active: IsPassengerSelectionActive }">
         <div class="passenger-cta-btn"></div>
      </div>

      <div class="passenger-information-container" v-if="IsPassengerInfant">
         <div class="row">
            <div class="col">
               <span class="info-label">{{ passenger.paxType }} {{ $t("ancillarySeatMap_lblPassenger") }}</span>
               <span>{{ passenger.paxName }} </span>
            </div>
            <div class="col">
               <span class="info-label">{{ $t("ancillarySeatMap_lblSeat") }}</span>

               <span>{{ passenger.seat }} </span>
            </div>
         </div>
      </div>
      <div class="passenger-information-container" v-else>
         <div class="row">
            <div class="col">
               <span class="info-label">{{ $t("ancillarySeatMap_lblPassenger") }}</span>
               <span>{{ passenger.paxName.trimmer(11) }} </span>
            </div>
            <div class="col" v-show="!InitialSeat">
               <span class="info-label">{{ $t("ancillarySeatMap_lblPrice") }}</span>

               <span>{{ passenger.price ?? "-" | price(currency) }} </span>
            </div>
         </div>
         <div class="row">
            <div class="col">
               <span class="info-label">{{ $t("ancillarySeatMap_lblPaxType") }}</span>
               <span>{{ passenger.paxType }} </span>
            </div>
            <div class="col">
               <span class="info-label">{{ $t("ancillarySeatMap_lblSeat") }}</span>
               <span>{{ passenger.seat }} - {{ passenger.cabinType }}</span>
            </div>
         </div>
      </div>

      <div class="cancel-seat-btn" :style="{ visibility: SeatSelected && !IsPassengerInfant ? '' : 'hidden' }">
         <button @click="handlerCancelSeat">{{ $t("ancillarySeatMap_lblCancel") }}</button>
      </div>

      <!-- <div class="infant-info-wrapper" v-if="IsPassengerInfant">
         {{ passenger.paxType }}
      </div> -->
   </div>
</template>

<script>
// import UITooltip from "@/components/utils/GtsToolTips.vue";
export default {
   name: "AncillarySeatMap",
   props: {
      passenger: Object,
      currency: String,
   },
   components: {
      // UITooltip,
   },
   computed: {
      IsPassengerSelectionActive() {
         return this.passenger.selected;
      },
      IsPassengerInfant() {
         return this.passenger.paxTypeEnum == 3;
      },
      SeatSelected() {
         return this.passenger.seat != null;
      },
      InitialSeat() {
         return this.passenger.initialSeat;
      },
   },
   methods: {
      handlerSelectSeat() {
         if (!this.IsPassengerInfant && !this.InitialSeat) {
            this.$store.dispatch("seatmap/updatePaxSelection", this.passenger);
         }
      },

      handlerCancelSeat() {
         this.$store.commit("seatmap/cancelSeatSelection", this.passenger);
      },
   },
};
</script>

<style lang="scss" scoped>
.ancillary-seat-map-passenger-container {
   display: flex;
   // border: 1px solid #ebebeb;
   padding: 0.5rem 0.75rem;
   border-radius: 0.5rem;
   margin: 1rem 0;
   width: fit-content;
   min-width: 350px;
   cursor: pointer;
   // outline-width: 3px;
   outline-color: #eee;
   outline-style: solid;

   &.selected {
      // background-color: var(--accent-primary);
      background-color: #f0faff;
      outline: 1.5px solid #ceedfd;
      color: #3c67b2;

      // color: #fff;
      // outline: 2px solid rgba(51, 184, 255, 0.3882352941);
   }
   &.active {
      // outline: 4px solid #ccc;
      // background-color: #eee;
      // background-color: var(--accent-primary);
      // outline: none;
      // color: #fff;
      // background-color: #ebffed !important;
      // transform: scale(1.05);
      // background-color: #dcf0fa !important;
      // background-color: #f0faff !important;
      outline: 2.5px solid var(--accent-primary);
      color: var(--primary);
      cursor: default !important;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
   }

   &.initialSeat {
      // display: none;
      cursor: not-allowed !important;

      .passenger-cta,
      .cancel-seat-btn {
         visibility: hidden;
      }
   }

   &.noPointer {
      cursor: not-allowed;
      // opacity: 0.7;
      // outline: 2.5px solid var(--accent-primary);
      // color: var(--primary);

      .passenger-cta {
         visibility: hidden;
         .passenger-cta-btn {
            border: 3px solid #eee;
            outline: 3px solid #e4e4e4;

            &::after {
               content: "";
               width: 70%;
               height: 70%;
               display: flex;
               border-radius: 50%;
            }
         }
      }
      &:hover {
         background-color: #fff !important;
      }
   }
   &:hover {
      background-color: #ebffed;
      background-color: #eee;
      // outline-color: #ccc;
      // outline-color: var(--accent-primary);
   }

   .passenger-information-container {
      width: 100%;
      // background: red;

      .row {
         margin-bottom: 0.5rem;

         &:last-child {
            margin-bottom: 0 !important;
         }
         .col {
            display: flex;
            flex-direction: column;
            width: fit-content;

            span {
               white-space: nowrap;
               font-weight: 500;
               font-size: 1rem;

               &.info-label {
                  font-weight: 400;
                  font-size: 0.85rem;
                  opacity: 0.75;
               }
            }
         }
      }
   }
   .passenger-cta {
      display: flex;
      align-items: center;
      margin-right: 1rem;

      &.active {
         .passenger-cta-btn {
            &::after {
               background-color: var(--accent-primary);
            }
         }
      }

      .passenger-cta-btn {
         display: block;
         $size: 28px;
         width: $size;
         height: $size;
         background-color: #fff;
         border: 3px solid var(--accent-primary);
         outline: 3px solid #d3f0ff;
         border-radius: 25rem;
         display: flex;
         align-items: center;
         justify-content: center;

         &::after {
            content: "";
            width: 70%;
            height: 70%;
            display: flex;
            border-radius: 50%;
         }
      }
   }
   .cancel-seat-btn {
      display: flex;
      align-items: center;

      // background-color: #3b66ae;
      // height: 48px;
      // padding: 1rem;
      // color: #fff;
      button {
         background-color: var(--secondary);
         background-color: #363636;
         background-color: #f76262;
         // height: 48px;
         padding: 0.65rem 1rem;
         color: #fff;
         border-radius: 0.5rem;
         font-weight: 600;
         font-size: var(--small);

         &:hover {
            background-color: #e03e3e;
         }
         // background-color: var(--primary);
         // background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi43MjgiIGhlaWdodD0iMTIuNzI4IiB2aWV3Qm94PSIwIDAgMTIuNzI4IDEyLjcyOCI+CiAgPGcgaWQ9Ikdyb3VwXzEyMDAyIiBkYXRhLW5hbWU9Ikdyb3VwIDEyMDAyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzYuNzcgLTEzMTguNzU0KSByb3RhdGUoNDUpIj4KICAgIDxsaW5lIGlkPSJMaW5lXzExMzAiIGRhdGEtbmFtZT0iTGluZSAxMTMwIiB5Mj0iMTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk3My41IDkwNi41KSByb3RhdGUoOTApIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIi8+CiAgICA8bGluZSBpZD0iTGluZV8xMjY4IiBkYXRhLW5hbWU9IkxpbmUgMTI2OCIgeTI9IjEyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NjcuNSA5MDAuNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiLz4KICA8L2c+Cjwvc3ZnPgo=") !important;
         // background-repeat: no-repeat;
         // background-position: center;
         // background-size: cover;
         // width: 32px !important;
         // height: 32px !important;
      }
   }
}
</style>
